import { Badge, Col, Collapse, Image, Row, Space } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import { formatDateTime } from 'helpers/format'
import { Data } from 'Store/categories/types'
import { appConfig } from 'config'
import { ActionButton } from 'Components/button'
import { MyTheme } from 'Components/common/Theme'
import { CategoriesStatus, ImageFallback } from 'helpers/constanst'
const { Panel } = Collapse

type Props = {
  data: Data[]
  onClickDelete: (id: number) => void
  onClickEdit: (id: number) => void
}

const CategoryCollapse = (props: Props) => {
  const { data, onClickDelete, onClickEdit } = props

  const renderActionButton = (id: number) => {
    return (
      <Space size="middle" style={{ margin: '5px 0' }}>
        <ActionButton
          text=""
          icon={<EditOutlined />}
          label="แก้ไข"
          action="edit"
          onClick={(event: any) => {
            event.stopPropagation()
            onClickEdit(id)
          }}
        />
        <ActionButton
          text=""
          icon={<DeleteOutlined />}
          label="ลบ"
          action="deleted"
          onClick={(event: any) => {
            event.stopPropagation()
            onClickDelete(id)
          }}
        />
      </Space>
    )
  }

  const genTitle = (item: Data) => (
    <Row gutter={16} align="middle" justify="start">
      <Col xs={24} flex="100px">
        <ThumbImage
          src={appConfig.assetCdnEndpoint + item.logo}
          onClick={(event: any) => event.stopPropagation()}
          fallback={ImageFallback}
        />
      </Col>
      <Col xs={24} flex="auto">
        <CateName>{item.name}</CateName>{' '}
        <Badge status={item.status === CategoriesStatus.ACTIVE ? 'success' : 'error'} />
        <br />
        <Info>วันที่สร้าง : {formatDateTime(item.created_at)}</Info>
      </Col>
    </Row>
  )

  const genHeader = (item: Data) => (
    <Row justify="space-between" align="middle">
      <Col>{genTitle(item)}</Col>
      <Col>{renderActionButton(item.id)}</Col>
    </Row>
  )

  const renderCat = (data: any) => {
    return (
      data &&
      data.map((item: Data) => {
        const hasChild = (item.child && item.child.length > 0) || false
        return (
          <Panel
            header={genHeader(item)}
            key={item.id}
            showArrow={hasChild}
            collapsible={!hasChild ? `disabled` : 'header'}
          >
            {hasChild && <MyCollapse expandIconPosition="right">{renderCat(item.child)}</MyCollapse>}
          </Panel>
        )
      })
    )
  }

  return <MyCollapse expandIconPosition="right">{renderCat(data)}</MyCollapse>
}

const MyCollapse = styled(Collapse)`
  background-color: #fff;
  border-radius: 5px;
  .ant-collapse-item-disabled {
    .ant-collapse-header {
      cursor: default;
    }
  }

  span.desc {
    color: #666666;
    font-size: 11px;
  }

  .ant-collapse-arrow {
    top: 30% !important;
  }
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 90px;
  height: 50px;
  object-fit: contain;
`

const CateName = styled.span`
  color: #000;
`

const Info = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

export default CategoryCollapse
